import { api } from './api';

export const poolPredictionsAPI = {
  // User endpoints
  listMarkets: (status = null, category = null, limit = 50) => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (category) params.append('category', category);
    if (limit) params.append('limit', limit);
    return api.get(`/pool-predictions/markets?${params.toString()}`);
  },
  
  getMarketDetails: (marketId) => api.get(`/pool-predictions/markets/${marketId}`),
  
  participate: (marketId, data) => api.post(`/pool-predictions/markets/${marketId}/participate`, data),
  
  createMultiBet: (data) => api.post('/pool-predictions/multi-bet', data),
  
  getMyParticipations: (status = null) => {
    const params = status ? `?status=${status}` : '';
    return api.get(`/pool-predictions/my-participations${params}`);
  },
  
  getMyMultiBets: () => api.get('/pool-predictions/my-multi-bets'),
};

export const poolAdminAPI = {
  // Admin market management
  createMarket: (data) => api.post('/admin/pool-predictions/markets', data),
  
  updateMarket: (marketId, data) => api.put(`/admin/pool-predictions/markets/${marketId}`, data),
  
  publishMarket: (marketId) => api.put(`/admin/pool-predictions/markets/${marketId}/publish`),
  
  closeMarket: (marketId) => api.put(`/admin/pool-predictions/markets/${marketId}/close`),
  
  cancelMarket: (marketId, reason) => api.delete(`/admin/pool-predictions/markets/${marketId}`, { data: { reason } }),
  
  // Settlement
  initiateSettlement: (marketId, winningOutcome) => api.post(`/admin/pool-predictions/markets/${marketId}/settle`, { winning_outcome: winningOutcome }),
  
  approveSettlement: (settlementId) => api.post(`/admin/pool-predictions/settlements/${settlementId}/approve`),
  
  listPendingSettlements: () => api.get('/admin/pool-predictions/settlements/pending'),
  
  listAllSettlements: (status = null) => {
    const params = status ? `?status=${status}` : '';
    return api.get(`/admin/pool-predictions/settlements${params}`);
  },
  
  // Configuration
  getConfig: () => api.get('/admin/pool-predictions/config'),
  
  updateConfig: (data) => api.put('/admin/pool-predictions/config', data),
  
  // Analytics
  getAnalytics: () => api.get('/admin/pool-predictions/analytics'),
};
